import { createActionType, createApiActionType } from 'app/store/utils';

const type = createActionType('projectModels');
const apiType = createApiActionType('jobs');

export const TOGGLE_CREATE_JOB_DIALOG = type('ToggleCreateJobDialog');

export const LIST_TAGS_ACTION_TYPE = apiType('ListTags');
export const LIST_MODELS_ACTION_TYPE = apiType('ListModels');
export const VALIDATE_JOBS_ACTION_TYPE = apiType('ValidateJobs');
export const UPDATE_JOBS_ACTION_TYPE = apiType('UpdateJobs');

export const GET_OUTPUT_COLUMNS_ACTION_TYPE = apiType('GetOutputColumns');
export const TOGGLE_DEPLOY_MODEL_DIALOG = type('ToggleDeployModelDialog');
export const DEPLOY_MODEL_ACTION_TYPE = apiType('DeployModel');
export const REDEPLOY_MODEL_ACTION_TYPE = apiType('RedeployModel');

export const LIST_ENVIRONMENT_DATABASES = apiType('ListEnvironmentDatabases');
export const LIST_ENVIRONMENT_SCHEMAS = apiType('ListEnvironmentSchemas');
export const LIST_ENVIRONMENT_ROLES = apiType('ListEnvironmentRoles');
export const LIST_ENVIRONMENT_WAREHOUSES = apiType('ListEnvironmentWarehouses');
export const LIST_DATABASES = apiType('ListDatabases');
export const LIST_SCHEMAS = apiType('ListSchemas');

export const TOGGLE_CONVERT_TO_MODEL_DIALOG = type('ToggleConvertToModelDialog');
export const OPEN_CONVERT_ALL_DIALOG = type('OpenConvertAllDialog');
export const CLOSE_CONVERT_ALL_DIALOG = type('CloseConvertAllDialog');
export const CONVERT_TO_MODEL_ACTION_TYPE = apiType('ConvertToModel');

export const QUEUE_DEPLOYMENTS_FOR_CONVERSION = type('QueueDeploymentsForConversion');

export const GET_PROJECT_MODELS_JOB_RUNS = type('GetProjectModelsJobRuns');
export const GET_LAST_MODEL_JOB_RUN = apiType('GetLast_MODEL_JOB_RUN');
